import React, { useState } from 'react';

export default function ClosedDoor() {
  const [showCredits, setShowCredits] = useState(false);

  return (
    <div className="auth-screen">
      <div className="disclosure-glow" aria-hidden="true" />
      <main className="auth-panel">
        <p className="brand-eyebrow">The puzzle box is sealed</p>
        <h1 className="codename-reveal">Door Closed</h1>
        
        <p className="auth-sub">
          While we&apos;re sad the Riddler has been put in jail, word has that the Riddler will likely escape again next year.
        </p>
        
        <p className="auth-sub" style={{ fontStyle: 'italic', opacity: 0.8 }}>
          It&apos;s true.
        </p>

        <div className="auth-resources" style={{ marginTop: '2rem', textAlign: 'left', width: '100%', maxWidth: '300px', marginInline: 'auto' }}>
          <details open>
            <summary className="auth-top-toggle" style={{ justifyContent: 'flex-start', cursor: 'pointer', marginBottom: '1rem' }}>
              Resources
            </summary>
            <div className="auth-sub" style={{ textAlign: 'left', padding: '0 1rem' }}>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>
                  <a href="https://github.com/ryandotclair/riddler" target="_blank" rel="noopener noreferrer" className="chat-link">
                    GitHub Repository
                  </a>
                </li>
                <li>
                  <a href="https://example.com/congrats-links" target="_blank" rel="noopener noreferrer" className="chat-link">
                    Event Resources
                  </a>
                </li>
              </ul>
            </div>
          </details>

          <details style={{ marginTop: '1rem' }}>
            <summary className="auth-top-toggle" style={{ justifyContent: 'flex-start', cursor: 'pointer' }}>
              Credits
            </summary>
            <div className="auth-sub" style={{ textAlign: 'left', padding: '0 1rem' }}>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li>Ryan Clair</li>
                <li>Anish Patel</li>
              </ul>
            </div>
          </details>
        </div>
      </main>
    </div>
  );
}
